"use client";
import StickyLogoBar from "./StickyLogoBar";
import { useEffect, useState, useRef } from "react";
import Link from "next/link";

export default function WapoHeader() {
    const headerRef = useRef(null);
    const [showStickyLogo, setShowStickyLogo] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => setShowStickyLogo(!entry.isIntersecting),
            {
                rootMargin: "-100px",
                threshold: 0,
            }
        );

        if (headerRef.current) observer.observe(headerRef.current);
        return () => {
            if (headerRef.current) observer.unobserve(headerRef.current);
        };
    }, []);

    return (
        <>
            {/* Sticky Logo Bar (position: fixed or sticky) */}
            <StickyLogoBar show={showStickyLogo} />

            <div
                ref={headerRef}
                className="bg-white dark:bg-zinc-950 z-40 border-b border-gray-200 dark:border-zinc-800"
            >
                {/* 💡 Prevent layout shift with pinned width boxes */}
                <div className="relative h-[200px] sm:h-[220px] md:h-[250px] flex items-center justify-between px-6 max-w-screen-xl mx-auto">
                    <div className="w-[120px] sm:w-[160px]" aria-hidden />

                    <div className="flex flex-col items-center text-center leading-tight space-y-2 max-w-[60vw] flex-shrink-0">
                        <Link
                            href="/"
                            className={
                                "font-Playfair no-copy text-[2.375rem] sm:text-[2.625rem] md:text-[3.375rem] lg:text-[4.5rem] font-extrabold text-black dark:text-white whitespace-nowrap"
                            }
                        >
                            MyBlog Times
                        </Link>

                        <span className="no-copy text-xs sm:text-sm md:text-base lg:text-lg text-gray-500 uppercase tracking-widest pb-1 sm:pb-2">
                            Headlines & Beyond
                        </span>
                    </div>

                    <div className="w-[120px] sm:w-[160px]" aria-hidden />
                </div>
            </div>
        </>
    );
}
